import { GetStaticProps } from 'next'
import { getAllNewsForHome } from '#/containers/News/lib/api'

export { default } from '#/containers/News'

export const getStaticProps: GetStaticProps = async ({ preview = false }) => {
  const allNews = await getAllNewsForHome(preview, 1000, null)

  return {
    props: { allNews, preview },
    revalidate: 1
  }
}
